<div id="driver-selection-list" class="d-flex flex-column h-100 gap-1" 
     tabindex="0" 
     (focus)="isFocused = true" 
     (blur)="isFocused = false"
     (click)="$event.currentTarget.focus()">

  <div class="d-flex flex-row align-items-center justify-content-between  w-100">
    <div class="w-100 h-100 d-flex align-items-center gap-2">
      <div class="selection-list-filter"
          [class.active]="(filter$ | async) === 'all'"
          (click)="setFilter('all')"
          [pTooltip]="'Todos'"
          tooltipPosition="top"
          >
        <i class="fas fa-users"></i>
        {{ totalCount$ | async }}
      </div>

      <div class="selection-list-filter"
          [class.active]="(filter$ | async) === 'checklist'"
          (click)="setFilter('checklist')"
          [pTooltip]="'Con Checklist'"
          tooltipPosition="top"
          >
        <i class="fas fa-check"></i>
        {{ withChecklistCount$ | async }}
      </div>

      <div class="selection-list-filter"
          [pTooltip]="'Enrolados'"
          tooltipPosition="top"
          [class.active]="(filter$ | async) === 'enrolled'"
          (click)="setFilter('enrolled')">
        <i class="fas fa-users-cog"></i>
        {{ enrolledCount$ | async }}
      </div>

      <div class="selection-list-filter"
          [pTooltip]="'Evaluados'"
          tooltipPosition="top"
          [class.active]="(filter$ | async) === 'evaluated'"
          (click)="setFilter('evaluated')">
        <i class="fas fa-user-check"></i>
        {{ evaluatedCount$ | async }}
      </div>
    </div>
    <div class="d-flex flex-row gap-1">
      <button class="button-icon" (click)="onActivateFullscreen()"
        [pTooltip]="'Pantalla Completa'"
        tooltipPosition="top"
      >
        <i class="fas fa-expand"></i>
      </button>
      <button class="button-icon" (click)="onToggleDisplayOnPanel()"
        [pTooltip]="'Minimizar / Maximizar'"
        tooltipPosition="top"
      >
        <i class="far fa-window-maximize"></i>
      </button>
      <button class="button-icon" (click)="onClosePanel()"
        [pTooltip]="'Cerrar'"
        tooltipPosition="top"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="h-100 selector-list-container" #verticalCarousel>
    <div class="d-flex flex-column" *ngFor="let driver of filteredDrivers$ | async">
      <app-driver-selection-item [driver]="driver" [currentFilter]="filter$ | async" [activeFullScreeenFn]="onActivateFullscreen.bind(this)"></app-driver-selection-item>
    </div>
  </div>
</div>

<div #pantalla class="contenedor oculto fullscreen-container">

  <!-- LEFT: MEDIA -->
  <div class="media-viewer">
    <!-- contenido principal -->

    <ng-container *ngIf="multimedias[selectedMediaIndex] as media">
      <img *ngIf="media.type === 'image'" [src]="media.url" class="media-content" />
      <video *ngIf="media.type === 'video'" [src]="media.url" controls autoplay class="media-content"></video>
    </ng-container>
    <div class="w-100 d-flex justify-content-start px-2 py-1 opacity-50">
      <span class="p-0 fs-4">{{driverFromEventName$ | async}}</span>
    </div>

    <!-- selector de media -->
    <div class="media-selector">
      <button *ngFor="let media of multimedias; let i = index"
              (click)="selectedMediaIndex = i"
              class="d-flex flex-column align-items-center justify-content-center"
              [class.active]="i === selectedMediaIndex">

        <!-- mostrar icono según tipo -->
        <i class="far fa-image display-3" *ngIf="media.type === 'image'"></i>
        <i class="fas fa-play-circle display-3" *ngIf="media.type === 'video'"></i>

        {{
          media.type === 'image'
            ? 'Imagen'
            : media.type === 'video'
            ? 'Video'
            : media.type
        }}
      </button>
    </div>
  </div>

  <!-- RIGHT: DRIVER -->
  <div class="media-viewer">
    <ng-container *ngIf="(filteredDrivers$ | async) as drivers">
      <ng-container *ngIf="getSelectedDriver(drivers) as driver">
        <img [src]="driver.image" [alt]="driver.name" class="media-content" (dblclick)="onDriverDblClick(driver)"/>
        <div class="w-100 d-flex justify-content-start align-items-center px-2 gap-3 py-1 opacity-50">
          <span class="p-0 fs-4">{{driver.name}}</span>
          <span class="p-0 fs-6 opacity-75" *ngIf="getDriverDisplayDate(driver)">{{ getDriverDisplayDate(driver) }}</span>

          <div class="d-flex flex-row gap-2">
            <i class="fas fa-user-circle" *ngIf="driver.fromEvent" [pTooltip]="'Del evento'" tooltipPosition="top"></i>
            <i class="fas fa-check" *ngIf="driver.withChecklist" [pTooltip]="'Checklist'" tooltipPosition="top"></i>
            <i class="fas fa-user-cog" *ngIf="driver.enrolled" [pTooltip]="'Enrolado'" tooltipPosition="top"></i>
            <i class="fas fa-user-check" *ngIf="driver.evaluated" [pTooltip]="driver.frequency ? ('Evaluado (' + driver.frequency + ')') : 'Evaluado'" tooltipPosition="top"></i>
          </div>
        </div>
      </ng-container>
    </ng-container>
      <!-- carrusel de imágenes del driver -->
      <div #driverCarousel class="media-selector">
        <ng-container *ngFor="let driver of filteredDrivers$ | async">
          <img
            [class.selected]="driver.id == selectedDriverId"
            (click)="onSelectDriverId(driver.id)"
            (dblclick)="onDriverDblClick(driver)"
            [src]="driver.image">
        </ng-container>
      </div>
  </div>

</div>
